/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { type CalendarEntity, calendarSchema } from '@axiom/domain';

export const calendarDtoSchema = calendarSchema.pick({ "id": true, "timezone": true });
export type CalendarDto = Pick<CalendarEntity, "id" | "timezone"> & z.infer<typeof calendarDtoSchema>;
